<script setup>
import { ref, onMounted } from 'vue';
import { get_terms, create_term, delete_term, update_term } from '@/services/terms';
const isLoading = ref(true)
const isSubmitting = ref(false)
const currentStatus = ref({
  id: '',
  status: 'new',
  name: '',
})
const statuses = ref([])

const taxonomy = 'report_status'
const terms = ref([])
onMounted(async ()=>{
  let response = await get_terms(taxonomy)
  statuses.value = response.result.data.data
  isLoading.value = false
})

function editTerm(index, termObj){
  currentStatus.value.name = termObj.attributes.name
  currentStatus.value.status = 'edit'
  currentStatus.value.id = termObj.id
}

async function createStatus(){
  isSubmitting.value = true
  const term = {
    name: currentStatus.value.name,
    term_taxonomy_attributes:{
      taxonomy
    }
  }

  if (currentStatus.value.status == 'new'){
    let response = await create_term(term)
    Swal.fire({
      title: 'Added',
      text: 'Status successfully added',
      icon: 'success'
    })
    statuses.value.push(response.result.data.data)
    currentStatus.value.name = ''
  }else{
    let response = await update_term(currentStatus.value.id, term)
    let tempTerm = response.result.data.data
    statuses.value = statuses.value.map(term => {
      if (term.id == tempTerm.id){
        return tempTerm
      }else{
        return term
      }
    })
    currentStatus.value = {
      id: '',
      status: 'new',
      name: '',
    }
  }
  isSubmitting.value = false
}

async function deleteTerm(index, term_id){
  let response = await delete_term(term_id)
  if (response.error){
    Swal.fire({
      title: 'Error',
      html: response.result.error,
      icon: 'error'
    })
  }else{
    Swal.fire({
      title: 'Deleted',
      text: 'Status successfully deleted',
      icon: 'success'
    })
    statuses.value.splice(index, 1)
  }
}

function cancelEdit(){
  currentStatus.value = {
    id: '',
    status: 'new',
    name: '',
  }
}
</script>

<template>
  <div class="container-fluid">
    <Breadcrumbs main="Edit Report Status"/>

    
    <!-- <template v-else> -->
      <!-- Page title -->
      <div class="d-flex align-items-center">
        <div>
          <h4 class="mb-0">Report Statuses</h4>
          <p>List of report status in the system</p>
        </div>
      </div>

      <div class="row mt-3">
        <!-- add/edit Form -->
        <div class="col-4">
          <div class="card">
            <div class="card-body">
              <form @submit.prevent="createStatus()">
                <div class="row mb-3">
                  <label class="form-label">Status</label>
                  <input 
                    class="form-control"
                    type="text" 
                    placeholder="Status name" 
                    v-model="currentStatus.name"
                  >
                </div>
                <button :disabled="isSubmitting" class="btn btn-light-success" type="submit">
                  <div v-if="isSubmitting" class="spinner-border spinner-border-sm" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  <template v-else>
                    <template v-if="currentStatus.status == 'new'">
                      Add Status
                    </template>
                    <template v-else>
                      Update Status
                    </template>
                  </template>
                </button>
                <button v-if="currentStatus.status == 'edit'" @click="cancelEdit()" class="ms-1 btn btn-light-danger">
                  Cancel
                </button>
              </form>
            </div>
          </div>
        </div>
        <!-- list -->
        <div class="col-8 card">
          <div class="card-body">
            <LoadingCard v-if="isLoading" loadingType="list" />
            <div v-else class="table-responsive">
              <table class="table user-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th class="text-center">Action</th>
                  </tr>
                </thead>
                <tbody v-auto-animate>
                  <tr v-for="(statusObj, index) in statuses">
                    <td :class="currentStatus.id == statusObj.id ? 'bg-secondary-subtle text-dark': ''">{{ statusObj.attributes.name }}</td>
                    <td class="text-center" :class="currentStatus.id == statusObj.id ? 'bg-secondary-subtle text-dark': ''">
                      <button @click="editTerm(index, statusObj)" :disabled="currentStatus.id == statusObj.id" class="me-2 btn rounded-circle p-2 btn-light-primary">
                        <vue-feather type="edit-2" size="1.15rem"/>
                      </button>
                      <template v-if="index > 4">
                        <button @click="deleteTerm(index, statusObj.id)" class="btn rounded-circle p-2 btn-light-danger">
                          <vue-feather type="trash" size="1.15rem"/>
                        </button>
                      </template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    <!-- </template> -->
  </div>
</template>